module.exports = __webpack_public_path__ + "static/img/service_introduce_01_zh_H5.1501201.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/service/service_introduce_01_zh_H5.png
// module id = FSYJ
// module chunks = 34